export default {
  "name": "Naked in Paradise",
  "slug": "naked-in-paradise",
  "path": "/naked-in-paradise",
  "componentName" : "NakedInParadise",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}